import React from 'react';
import { SearchIcon } from '../ios/IOSIcons';

interface ChatSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
}

/**
 * iOS 风格的聊天搜索栏
 */
export const ChatSearchBar: React.FC<ChatSearchBarProps> = ({
  value,
  onChange,
  onFocus,
  onBlur,
}) => {
  return (
    <div className="px-4 py-2">
      <div className="relative">
        <div className="absolute left-3 top-2.5 w-5 h-5 text-ios-gray dark:text-ios-dark-gray">
          <SearchIcon />
        </div>
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onFocus={onFocus}
          onBlur={onBlur}
          placeholder="搜索"
          className="w-full h-10 pl-10 pr-4 bg-ios-gray5 dark:bg-ios-dark-gray4 rounded-ios-lg text-ios-body placeholder-ios-gray dark:placeholder-ios-dark-gray focus:outline-none"
        />
        {value && (
          <button
            onClick={() => onChange('')}
            className="absolute right-3 top-2.5 w-5 h-5 bg-ios-gray3 dark:bg-ios-dark-gray3 rounded-full flex items-center justify-center text-white"
          >
            <svg className="w-3 h-3" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 3L3 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M3 3L9 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};
